<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getSubcontractGoodReceipts"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-subcontract-good-receipt-number" label-cols-sm="4" label-cols-lg="3" label="Subcontract Good Receipt Number" label-for="filter-subcontract-good-receipt-number" size="sm" :model.sync="filter.subcontractGoodReceiptNumber" />
					<app-input-combobox-autocomplete :options="subcontractRequestDeliverys" optionsLabel="requestDeliveryNumber" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Subcontract Request Delivery Number" id="filter-" size="sm" :model.sync="filter.subcontractRequestDeliveryId" @input="getSubcontractRequestDeliverys" @focus="getSubcontractRequestDeliverys" />
					<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Document Status" id="filter-" size="sm" :model.sync="filter.documentStatusId" @input="getDocumentStatuss" @focus="getDocumentStatuss" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-surat-jalan" label-cols-sm="4" label-cols-lg="3" label="Surat Jalan" label-for="filter-surat-jalan" size="sm" :model.sync="filter.suratJalan" />
					<app-input-textarea id="fieldset-remarks" label-cols-sm="4" label-cols-lg="3" label="Remarks" label-for="filter-remarks" size="sm" :model.sync="filter.remarksMultiple" />

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getSubcontractGoodReceipts"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Subcontract Good Receipt</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="false" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/subcontractgoodreceipt/SubcontractGoodReceipt.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button v-if="false" class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
					
					<b-overlay v-if="false"
							   :show="isDeleteBusy"
							   rounded
							   opacity="0.6"
							   spinner-small
							   spinner-variant="primary"
							   class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-subcontractgoodreceipt" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="subcontractGoodReceipts" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="subcontractGoodReceipts.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<b-th stacked-heading="Subcontract Good Receipt Number" class="table-filter">
					<b-form-input id="input-subcontract-good-receipt-number-table" @input="getSubcontractGoodReceiptsWithoutLoading" v-model="filter.subcontractGoodReceiptNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Subcontract Request Delivery Number" class="table-filter">
					<v-select append-to-body label="requestDeliveryNumber" :options="subcontractRequestDeliverys" :value="filter.subcontractRequestDeliveryId" :reduce="item => item.id" v-model="filter.subcontractRequestDeliveryId" :filterable="true" @input="getSubcontractGoodReceiptsWithoutLoading" @search="getSubcontractRequestDeliverys"></v-select>
				</b-th>
				<b-th stacked-heading="Document Status" class="table-filter">
					<v-select append-to-body label="name" :options="documentStatuss" :value="filter.documentStatusId" :reduce="item => item.id" v-model="filter.documentStatusId" :filterable="true" @input="getSubcontractGoodReceiptsWithoutLoading" @search="getDocumentStatuss"></v-select>
				</b-th>
				<b-th stacked-heading="Surat Jalan" class="table-filter">
					<b-form-input id="input-surat-jalan-table" @input="getSubcontractGoodReceiptsWithoutLoading" v-model="filter.suratJalan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remarks" class="table-filter">
					<b-form-input id="input-remarks-table" @input="getSubcontractGoodReceiptsWithoutLoading" v-model="filter.remarks" size="sm"></b-form-input>
				</b-th>

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(subcontractgoodreceiptnumber)="row">

                <a @click="() => ( $router.push({ name: 'subcontractgoodreceiptdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.subcontractGoodReceiptNumber != null && row.item.subcontractGoodReceiptNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.subcontractGoodReceiptNumber.slice(0, 30) + (row.item.subcontractGoodReceiptNumber.length > 30 ? "..." : "" ) : row.item.subcontractGoodReceiptNumber : "" }}
						</a>
            
					</template>

			<template v-slot:cell(subcontractRequestDelivery)="row">
				{{ row.item.subcontractRequestDelivery != null ? row.item.subcontractRequestDelivery.requestDeliveryNumber : "" }}
			</template>
			<template v-slot:cell(documentStatus)="row">
				{{ row.item.documentStatus != null ? row.item.documentStatus.name : "" }}
			</template>
				<template v-slot:cell(remarks)="row">
					<app-long-text  :id="'remarks-' + row.index" :text="row.item != null ? (row.item.remarks != null && row.item.remarks != '' ? row.item.remarks : '') : ''" />
				</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2" v-if="false">
							<b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.documentStatusId" label="Document Status" :selected="row.item.documentStatus != null ? row.item.documentStatus.name : ''" :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-surat-jalan" label-cols-lg="12"  label="Surat Jalan" label-for="input-surat-jalan" size="sm" :model.sync="row.item.suratJalan"   :isEditable="false" :isUpdatable="true" />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="row.item.remarks"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(subcontractGoodReceiptsPaging != null ? subcontractGoodReceiptsPaging.dataCount : 0)"
									:per-page="(subcontractGoodReceiptsPaging != null ? subcontractGoodReceiptsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-subcontractgoodreceipt.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-subcontractgoodreceipt.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-subcontractgoodreceipt.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import SubcontractGoodReceipt from '@/models/SubcontractGoodReceipt/SubcontractGoodReceipt';
import SubcontractGoodReceiptList from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptList';
import SubcontractGoodReceiptFilter from '@/filters/SubcontractGoodReceipt/SubcontractGoodReceiptFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import SubcontractRequestDeliveryFilter from '@/filters/SubcontractRequestDelivery/SubcontractRequestDeliveryFilter';
import SubcontractRequestDelivery from '@/models/SubcontractRequestDelivery/SubcontractRequestDelivery';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import AppInputTextbox from '@/components/AppInputTextbox';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {
		SubcontractGoodReceipt, 
		SubcontractGoodReceiptList, 
		SubcontractGoodReceiptFilter, 
		AppLabel,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputTextarea,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				{"subcontractGoodReceiptNumber": {}, "class" : "th-subcontract-good-receipt-number first-child", "label" : "Subcontract Good Receipt Number", key: 'subcontractGoodReceiptNumber', sortable: true}, 
				{"subcontractRequestDelivery": {}, "class" : "th-subcontract-request-delivery", "label" : "Subcontract Request Delivery Number", key: 'subcontractRequestDelivery', sortable: true}, 
				{"documentStatus": {}, "class" : "th-document-status last-child", "label" : "Document Status", key: 'documentStatus', sortable: true}, 
				{"suratJalan": {}, "class" : "th-surat-jalan d-stack-none", "label" : "Surat Jalan", key: 'suratJalan', sortable: true}, 
				{"remarks": {}, "class" : "th-remarks d-stack-none", "label" : "Remarks", key: 'remarks', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			subcontractGoodReceipts: [],
			subcontractGoodReceiptsPaging: {},
			subcontractRequestDeliverys : [],
			documentStatuss : [],
			subcontractGoodReceiptDetails : [],
			subcontractGoodReceiptSuggestionDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: true,
			
		}
	},	methods : {
		getSubcontractGoodReceipts : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			SubcontractGoodReceipt.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.subcontractGoodReceipts = result.data
					this.subcontractGoodReceiptsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getSubcontractGoodReceiptsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			SubcontractGoodReceipt.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.subcontractGoodReceipts = result.data
					this.subcontractGoodReceiptsPaging = result
				}
			})
			.catch(error => {});
		},
		getSubcontractRequestDeliverys : async function(input) {
			let filter = new SubcontractRequestDeliveryFilter();
			if (input != undefined) {
				filter.requestDeliveryNumber = input;
			}
			await SubcontractRequestDelivery.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subcontractRequestDeliverys = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new SubcontractGoodReceiptFilter();
			this.getSubcontractGoodReceipts();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getSubcontractGoodReceipts();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				SubcontractGoodReceipt.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			SubcontractGoodReceipt.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			SubcontractGoodReceipt.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			SubcontractGoodReceipt.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'subcontractgoodreceiptedit';
						if(this.isScannerMode) {
							createRoute = 'subcontractgoodreceiptscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			SubcontractGoodReceipt.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'subcontractgoodreceiptedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			SubcontractGoodReceipt.deleteData(this, id).then(result => {
				if (result)
				{
					this.getSubcontractGoodReceipts();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				SubcontractGoodReceipt.deleteMultipleData(this).then(result => {
					this.getSubcontractGoodReceipts();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableSubcontractGoodReceiptParent = document.getElementById('table-list-subcontractgoodreceipt').parentNode;
			tableSubcontractGoodReceiptParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableSubcontractGoodReceiptParent.scrollWidth - tableSubcontractGoodReceiptParent.offsetWidth) == Math.ceil(tableSubcontractGoodReceiptParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableSubcontractGoodReceiptParent = document.getElementById('table-list-subcontractgoodreceipt').parentNode;
			tableSubcontractGoodReceiptParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableSubcontractGoodReceiptParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new SubcontractGoodReceiptFilter();
		this.getSubcontractRequestDeliverys()
		this.getDocumentStatuss()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Subcontract Good Receipt"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getSubcontractGoodReceipts();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getSubcontractGoodReceipts();
			}
		},
		sortDesc: {
			handler: function() {
				this.getSubcontractGoodReceipts();
			}
		},
		currentPage: {
			handler: function() {
				this.getSubcontractGoodReceipts();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getSubcontractGoodReceipts();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				SubcontractGoodReceipt.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "subcontractgoodreceiptindex") {
					this.getSubcontractGoodReceiptsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "subcontract_good_receipt").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
